UX.grid = {
    // refers to max values from SCSS
    screenXsMax: 576 - 1, // $screen-xs-max
    screenSmMax: 768 - 1, // $screen-sm-max
    screenMdMax: 1124 - 1, // $screen-md-max
    screenLgMax: 1200 - 1, // $screen-lg-max
};
